export const clone = <T extends object>(obj: T): T =>
  JSON.parse(JSON.stringify(obj));

export const reverseString = (string: string) => {
  return string.split('').reverse().join('');
};
